import React from 'react';
import { useAppData } from '../AppContext';
import { DEF_GEM } from '../store';
import './GemPortal.css';

const LinkIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2878c4" strokeWidth="2.2">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const GemPortal = () => {
  const { gem } = useAppData();
  const gemProducts = (gem && gem.length > 0) ? gem : DEF_GEM;

  return (
    <div className="gem-page">
      {/* Ticker */}
      <div className="gem-ticker">
        <div className="gem-ticker-inner">
          <span>Corrosion Protection for 20 years or more &nbsp;&mdash;&nbsp; This is Zinga Film Galvanising &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Corrosion Protection for 20 years or more &nbsp;&mdash;&nbsp; This is Zinga Film Galvanising</span>
        </div>
      </div>

      {/* Hero */}
      <div className="gem-hero">
        <div className="gem-hero-inner">
          <div className="gem-hero-text">
            <h1 className="gem-hero-title">GeM Listed Products</h1>
            <p className="gem-hero-sub">For GeM Customers, please refer below.</p>
            <div className="gem-note-box">
              <strong>Please Note :</strong> Zingalu and Zingaluspray are Silver colour, Zinga and Zingaspray are Grey colour
            </div>
          </div>
          <div className="gem-hero-logo">
            <div className="gem-logo-card">
              {/* GeM colorful logo text */}
              <div className="gem-logo-emblem">
                <svg viewBox="0 0 80 60" width="70" height="52" fill="none">
                  <circle cx="20" cy="30" r="18" fill="#f5a623" opacity="0.9"/>
                  <circle cx="40" cy="30" r="18" fill="#4a90d9" opacity="0.9"/>
                  <circle cx="60" cy="30" r="18" fill="#7ed321" opacity="0.85"/>
                </svg>
              </div>
              <div className="gem-logo-text-group">
                <span className="gem-logo-gem">GeM</span>
                <span className="gem-logo-full">Government</span>
                <span className="gem-logo-full">e Marketplace</span>
                <span className="gem-logo-tagline">Efficient &bull; Transparent &bull; Inclusive</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="gem-table-section">
        <div className="gem-table-wrap">
          <table className="gem-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Description</th>
                <th>Technical<br/>Data Sheet</th>
                <th>GeM Product ID</th>
                <th>Catalog ID</th>
                <th>GeM Link</th>
              </tr>
            </thead>
            <tbody>
              {gemProducts.map((p, i) => (
                <tr key={i}>
                  <td>
                    <a href={p.gemLink} target="_blank" rel="noopener noreferrer" className="gem-product-link">
                      {p.name}
                    </a>
                  </td>
                  <td className="gem-desc">{p.description}</td>
                  <td className="gem-icon-cell">
                    <a href={p.tdsLink} target="_blank" rel="noopener noreferrer" aria-label="Technical Data Sheet">
                      <LinkIcon />
                    </a>
                  </td>
                  <td className="gem-id-cell">
                    <span className="gem-id-label">GeM Product ID:</span>
                    <br />{p.gemProductId}
                  </td>
                  <td className="gem-id-cell">
                    <span className="gem-id-label">Catalog ID:</span>
                    <br />{p.catalogId}
                  </td>
                  <td className="gem-icon-cell">
                    <a href={p.gemLink} target="_blank" rel="noopener noreferrer" aria-label="GeM Link">
                      <LinkIcon />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GemPortal;
